import { Component, OnInit, Input } from '@angular/core';
import { RequestReponse } from '../../requets/shared/model/request-reponse.model';
import { StudentService } from '../shared/student.service';
import { MatDialogConfig, MatDialog } from '@angular/material';
import { HistoryStudentDialogComponent } from '../../../core/modal/history-student-dialog/history-student-dialog.component';
import { log } from 'console';

@Component({
  selector: 'app-student-request',
  templateUrl: './student-request.component.html',
  styleUrls: ['./student-request.component.scss']
})
export class StudentRequestComponent implements OnInit {

  @Input() request: RequestReponse;
  @Input() showButton = false;
  enableSpinner = false;
  constructor(private studentService: StudentService,
              private dialog: MatDialog) { }

  ngOnInit() {

  }

  showRecords() {
    this.enableSpinner = true;
    this.studentService.getStudentRecords(this.request.solicitud.cedula , this.request.programa.codigo, true).subscribe(
      (result) => {
        if (result.data) {
          const dialogConfig = new MatDialogConfig();
          dialogConfig.data =  { semestres: result.data.semestres.sort() , historia: result.data.historia,
                                  cedula: this.request.solicitud.cedula , nombre : this.request.nombreEstudiante,
                                  programa: this.request.programa.nombre};
          dialogConfig.width = '70%';
          this.dialog.open(HistoryStudentDialogComponent, dialogConfig);
          this.enableSpinner = false;
        }
      }
    );
  }

  showSubject() {

    const baseUrl = "https://ayudame2.udea.edu.co/php_materias_faltantes_estudiante";
   
    //const baseUrl = "https://link.udea.edu.co/alufaltgra";
    const params = new URLSearchParams();
  
    // Agregar los parámetros
    params.append('app', 'consultar');
    params.append('obligatorias', 'x');
    params.append('electivas', 'x');
    params.append('retorno', 'semestre_evaluacion');
    params.append('programa', this.request.programa.codigo.toString());
    params.append('estudiante', this.request.solicitud.cedula.toString());
    params.append('cerrar', 'x');
  
    // Construir la URL completa
    const fullUrl = `${baseUrl}?${params.toString()}`;
  
    // Configuración de la ventana emergente
    const width = 1000;
    const height = 600;
    const left = (window.screen.width - width) / 2;
    const top = (window.screen.height - height) / 2;
  
    // Abrir la ventana emergente
    window.open(
      fullUrl,
      'MateriasFaltantes',
      `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`
    );
  }
  
  

}
